import { useNavigate } from 'react-router-dom';
import { useI18n } from '../lib/i18n';

/** La escalera: el ícono del modo inspector (no existe en Lucide; mismo trazo que el resto). */
export function LadderIcon({ size = 18, strokeWidth = 1.9 }: { size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M7 3v18M17 3v18M7 7.5h10M7 12h10M7 16.5h10" />
    </svg>
  );
}

/**
 * EL BOTÓN DE LA ESCALERA, arriba a la derecha al lado del nombre (pedido del dueño 2026-09-17):
 * "yo también soy inspector; colócame un símbolo como una escalera y cuando le apriete me cambia
 * al modo inspector; en modo inspector, donde está la escalera, un símbolo de computer y ahí vuelvo
 * al modo adjuster". Solo aparece si `puedeModoInspector(me)` (rol inspector o `is_inspector`).
 */
export function InspectorModeButton() {
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <button type="button" className="topbar-link topbar-mode" title={t('nav.inspectorMode')} aria-label={t('nav.inspectorMode')} onClick={() => nav('/inspector')}>
      <LadderIcon />
      <span className="topbar-link-label">{t('nav.inspectorMode')}</span>
    </button>
  );
}
